/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { PlusCircleIcon16Light } from './PlusCircleIcon16Light';
import { PlusCircleIcon16Regular } from './PlusCircleIcon16Regular';
import { PlusCircleIcon16Solid } from './PlusCircleIcon16Solid';
import { PlusCircleIcon20Light } from './PlusCircleIcon20Light';
import { PlusCircleIcon20Regular } from './PlusCircleIcon20Regular';
import { PlusCircleIcon20Solid } from './PlusCircleIcon20Solid';
import { PlusCircleIcon24Regular } from './PlusCircleIcon24Regular';
import { PlusCircleIcon24Solid } from './PlusCircleIcon24Solid';
import { PlusCircleIcon32Regular } from './PlusCircleIcon32Regular';
import { PlusCircleIcon64Regular } from './PlusCircleIcon64Regular';
var sizes = {
    16: {
        light: PlusCircleIcon16Light,
        regular: PlusCircleIcon16Regular,
        solid: PlusCircleIcon16Solid,
    },
    20: {
        light: PlusCircleIcon20Light,
        regular: PlusCircleIcon20Regular,
        solid: PlusCircleIcon20Solid,
    },
    24: {
        regular: PlusCircleIcon24Regular,
        solid: PlusCircleIcon24Solid,
    },
    32: {
        regular: PlusCircleIcon32Regular,
    },
    64: {
        regular: PlusCircleIcon64Regular,
    },
};
export var PlusCircleIcon = forwardRef('PlusCircleIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
